module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAABPUlEQVRIie3WTytEURjH8Y8/G4sp2UyjlA1mIc1G2SjEvAJlQUkS2Uh5KUop0oiNjGI3O2VjwcIrMHa8AVaymJnN5F7nzly7+13e53ee7+l0eu4hI+Of6IkqlMvl3z4XsIkl5PGBe5zgtT1cq9Uixf0JNrmISlPeYgKz2MUWqqHNegNzxWbTQkR9CNeYSVt8iFxA7ihNcRFzgf1KmE5LPIa+QDGMpyVOStAmQ8T1hOK3tMQveAyU1kOzoUd9EJjbx2ea4gesij72d2zjJrBfost1ibOI2h2OE/QKFuc1hsNeRH0F5xhNU1zCM3YwGJHJYQ1PGjO9a/EIbjEc0kxjZlcx1a240pQnIYcLMb/cv8QLwmd0O5NY7lS83qG0xUan4qBLEsN8XDHuBXKq8ar4wncCYS8GcJVgTUZGevwAexkqJA40VWEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/peruser.png
// module id = JGxV
// module chunks = 1